module.exports = __webpack_public_path__ + "application/directives/breadcrumbs/breadcrumbs.template.html";